import React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { cn } from "../../lib/utils";
 
const Switch = React.forwardRef(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    ref={ref}
    className={cn(
      "peer inline-flex items-center justify-start shrink-0 cursor-pointer rounded-full transition-colors border-2 border-transparent",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=unchecked]:bg-gray-300",
      "data-[state=checked]:bg-pranaam-red",
      className
    )}
    {...props}
    style={{
      width: "48px",    
      height: "24px",    
      padding: "2px",    
      minWidth: "48px",  
      minHeight: "24px",
    }}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "block rounded-full bg-white shadow transition-transform duration-200",
        "data-[state=checked]:translate-x-[24px]",
        "data-[state=unchecked]:translate-x-0"
      )}
      style={{
        width: "20px",
        height: "20px",
      }}
    />
  </SwitchPrimitives.Root>
));
 
Switch.displayName = SwitchPrimitives.Root.displayName;
 
export { Switch };
 